export default "__VITE_PUBLIC_ASSET__aac1b265__"